import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";
import QuotationTypeService from "../../services/QuotationTypeService";
import BeneficiaryService from "../../services/BeneficiaryService";
import BeneficiaryTransactionService from "../../services/BeneficiaryTransactionService";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import BeneficiaryExistingCard from "../../components/BeneficiaryExistingCard";
import {Card, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import DropdownComponent from "../../components/DropdownComponent";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import QuotationResponseComponent from "../../components/QuotationResponseComponent";
import TransactionRequiredFieldsComponent from "../../components/TransactionRequiredFieldsComponent";
import TransactionCompleteCard from "../../components/TransactionCompleteCard";
import {getAmountValidation} from "../../domain/QuotationRequest";
import {stringValidator} from "../../domain/RequiredFieldTypes";
import BeneficiaryQuotationService from "../../services/BeneficiaryQuotationService";

const QUOTATION_REQUEST = "quotation request";
const QUOTATION_RESPONSE = "quotation response";
const CAPTURED_FIELDS = "captured fields";
const TRANSACTION_DETAILS = "transaction details";

const DECLARATION_LINK = process.env.REACT_APP_DECLARATION_LINK;
const T_AND_C_LINK = process.env.REACT_APP_T_AND_C_LINK;

class BeneficiaryTransactionCreation extends React.Component {

    constructor(props) {
        super(props);

        this.requiredFieldsRef = null;

        this.state = {
            currentTab: QUOTATION_REQUEST,
            loading: true,
            isValid: false,
            beneficiary: undefined,
            amount: undefined,
            quotationType: undefined,
            quotationResponse: undefined,
            showErrorModal: false,
            errors: null,

            inValidFields: {},
            validFields: {"amount": true, "quotationType": true}

        };

        this.schema = {
            amount: getAmountValidation("Amount", true),
            quotationType: stringValidator("quotationType", "Quotation Type", true)
        };

        this.requiredFieldsValid = this.requiredFieldsValid.bind(this);
    }

    componentDidMount() {

        if (this.props.setHeader)
            this.props.setHeader("New Transaction");

        let promiseArr = [];

        promiseArr.push(QuotationTypeService.retrieveQuotationTypes());
        promiseArr.push(BeneficiaryService.retrieve(this.props.beneficiary.id));

        Promise.all(promiseArr).then(promiseArrResponse => {

            let quotationTypeResponse = promiseArrResponse[0];
            let beneficiaryResponse = promiseArrResponse[1];

            this.setState({
                quotationTypeOptions: quotationTypeResponse,
                beneficiary: beneficiaryResponse,
                amount: beneficiaryResponse.amount,
                quotationType: beneficiaryResponse.quotationType,
                loading: false
            })
        });
    }

    validateInputFields(field) {

        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state[field];

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];

                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        })

    }

    getQuotation() {

        this.setState({
            loading: true
        }, () => {
            BeneficiaryQuotationService.requestQuotation({
                "beneficiary-id": this.state.beneficiary.id,
                "quotation-type": this.state.quotationType,
                "amount": this.state.amount
            }).then(response => {
                if (response["error-code"]) {
                    this.setState({
                        currentTab: QUOTATION_REQUEST,
                        loading: false,
                        showErrorModal: true,
                        errors: response
                    });
                } else {
                    this.setState({
                        quotationResponse: response,
                        currentTab: QUOTATION_RESPONSE,
                        loading: false
                    })
                }
            })
        });
    }

    isFormValid() {
        return (this.state.validFields["amount"] && this.state.validFields["quotationType"]);
    }

    captureRequiredFields() {

        if (this.state.quotationResponse.requiredFields.length > 0) {
            this.setState({
                currentTab: CAPTURED_FIELDS
            })
        } else {
            this.generateBeneficiaryTransaction();
        }
    }

    generateBeneficiaryTransaction() {

        let beneficiary = this.state.beneficiary;
        let quotationResponse = this.state.quotationResponse;

        let jsonObj = {};
        jsonObj["quotation-reference"] = quotationResponse.quotationReference;
        jsonObj["registration-id"] = beneficiary.registrationId;
        jsonObj["beneficiary-id"] = beneficiary.id;

        if (this.requiredFieldsRef !== null) {
            let requiredFieldsRef = this.requiredFieldsRef.getValues();
            jsonObj["captured-fields"] = requiredFieldsRef["captured-fields"];
        } else {
            jsonObj["captured-fields"] = [];
        }

        this.setState({
            loading: true,
            beneficiaryTransactionRequest: jsonObj
        }, () => this.createBeneficiaryTransaction())

    }

    createBeneficiaryTransaction() {

        BeneficiaryTransactionService.createTransaction(this.state.beneficiaryTransactionRequest).then(response => {
            if (response["error-code"]) {
                this.setState({
                    currentTab: QUOTATION_REQUEST,
                    loading: false,
                    showErrorModal: true,
                    errors: response
                })
            } else {
                this.setState({
                    transactionResponse: response,
                    currentTab: TRANSACTION_DETAILS,
                    loading: false
                })
            }
        })
    }

    requiredFieldsValid(isValid) {

        this.setState({
            isValid: isValid
        })
    }

    backToQuoteButtonClick(){
        this.setState({
            currentTab: QUOTATION_REQUEST
        })
    }


    render() {

        if (this.state.loading)
            return <SFXLoadingComponent/>;

        return <Fragment>

            {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}

        </Fragment>

    }

    renderContent(className) {

        return <Fragment>

            {this.state.showErrorModal && this.renderErrorModal(className)}

            {this.state.currentTab === QUOTATION_REQUEST && (className === 'mobile' ? this.renderQuotationRequest(className) : this.renderBrowserQuotationRequest(className))}
            {this.state.currentTab === QUOTATION_RESPONSE && (className === 'mobile' ? this.renderQuotationResponse(className) : this.renderBrowserQuotationResponse(className))}
            {this.state.currentTab === CAPTURED_FIELDS && (className === 'mobile' ? this.renderCapturedFields(className) : this.renderBrowserCapturedFields(className))}
            {this.state.currentTab === TRANSACTION_DETAILS && this.renderTransactionDetails(className)}

        </Fragment>

    }

    renderQuotationRequest(className) {

        return <Fragment>

            <div style={{padding: "5px"}}>
                <BeneficiaryExistingCard
                    beneficiary={this.state.beneficiary}
                />
            </div>

            <Row className={className + "_row"}>
                <Col>
                    <DropdownComponent
                        className={className + "_dropdown"}
                        options={this.state.quotationTypeOptions}
                        value={this.state.quotationType}
                        placeholder={"Quotation Type"}
                        onChange={(selectedOption) => {
                            let option;
                            if (selectedOption) {
                                option = selectedOption.value;
                            } else {
                                option = "";
                            }
                            this.setState({
                                quotationType: option
                            }, () => this.validateInputFields("quotationType"));
                        }}
                        clearable={true}
                    />
                    {this.state.inValidFields["quotationType"] && this.renderErrorMessage(className, "quotationType", this.state.inValidFields["quotationType"])}
                </Col>
            </Row>
            <Row className={className + "_row"}>
                <Col>
                    <Input
                        className={className + "_input"}
                        value={this.state.amount}
                        placeholder={"Select the amount"}
                        onChange={(event) => {
                            this.setState({
                                amount: event.target.value
                            }, () => this.validateInputFields("amount"))
                        }}
                    />
                    {this.state.inValidFields["amount"] && this.renderErrorMessage(className, "amount", this.state.inValidFields["amount"])}
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className={className + "_register_button_div"}>

                        <SFXButtonComponent
                            className={"btn-secondary"}
                            onClick={this.props.btnBackClick}
                            disabled={!this.isFormValid()}
                        >Back
                        </SFXButtonComponent>
                        {'  '}
                        <SFXButtonComponent
                            className={"btn-primary"}
                            onClick={() => this.getQuotation()}
                            disabled={!this.isFormValid()}
                        >Get Quote
                        </SFXButtonComponent>

                    </div>
                </Col>
            </Row>
        </Fragment>
    }

    renderBrowserQuotationRequest(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderQuotationRequest(className)}
        </Card>
    }

    renderQuotationResponse(className) {
        let bopDescription = ""
        if (this.state.quotationResponse.bopCategory !== "") {
            bopDescription = " as BOP Code " + this.state.quotationResponse.bopCategory.reportingCode + " - " + this.state.quotationResponse.bopCategory.outboundDescription;
        }
        return <Fragment>

            <QuotationResponseComponent
                className={className}
                quotationResponse={this.state.quotationResponse}
            />

            <hr />

            <div style={{fontWeight: "bold"}}>
                By acceptance of this quotation, you are confirming your transaction will be reported
                {bopDescription}. For more information, please view the
                <a href={DECLARATION_LINK}
                   target="_blank" rel="noopener noreferrer"> Declaration </a>and
                <a href={T_AND_C_LINK}
                   target="_blank" rel="noopener noreferrer"> Terms and Conditions</a>
            </div>

            <hr />

            <Row>
                <Col>
                    <div className={className + "_register_button_div"}>
                        <SFXButtonComponent className={"btn-secondary"}
                                            onClick={this.backToQuoteButtonClick.bind(this)}>
                            Back
                        </SFXButtonComponent>
                        {'  '}
                        <SFXButtonComponent
                            className={"btn-primary"}
                            onClick={() => this.captureRequiredFields()}
                        >{this.state.quotationResponse.requiredFields.length > 0 ? "Continue" : "Complete"}
                        </SFXButtonComponent>

                    </div>
                </Col>

                {this.state.quotationResponse.requiredFields.length > 0
                    ? <Col>
                        <div className={className + "_register_button_div"}>

                            <SFXButtonComponent
                                className={className + "_grey_oval_button"}
                                onClick={() => this.setState({currentTab: QUOTATION_REQUEST})}
                            >Back
                            </SFXButtonComponent>

                        </div>
                    </Col>
                    : null
                }
            </Row>
        </Fragment>
    }

    renderBrowserQuotationResponse(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderQuotationResponse(className)}
        </Card>
    }

    renderCapturedFields(className) {

        return <Fragment>

            <TransactionRequiredFieldsComponent
                className={className}
                registerRef={ref => this.requiredFieldsRef = ref}
                requiredFields={this.state.quotationResponse.requiredFields}
                isValid={this.requiredFieldsValid}
                saveBeneficiary={false}
            />

            <Row>
                <Col>
                    <div className={className + "_register_button_div"}>

                        <SFXButtonComponent
                            className={className + "_orange_oval_button"}
                            onClick={() => this.generateBeneficiaryTransaction()}
                            disabled={!this.state.isValid}
                        >Complete
                        </SFXButtonComponent>

                    </div>
                </Col>

            </Row>

        </Fragment>
    }

    renderBrowserCapturedFields(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderCapturedFields(className)}
        </Card>
    }

    renderTransactionDetails(className) {

        return <Fragment>

            <TransactionCompleteCard
                className={className}
                transaction={this.state.transactionResponse}
                btnBackClick={this.props.btnBackClick}
            />

        </Fragment>

    }

    renderErrorModal(className) {

        return <Modal isOpen={true}>

            <ModalHeader className={className + "_modal_header"}>{this.state.errors["message"]}</ModalHeader>
            <ModalBody>{this.state.errors["errors"]}</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({
                        showErrorModal: false,
                        currentTab: QUOTATION_REQUEST
                    })}
                >
                    Close
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }

    renderErrorMessage(className, field, message) {
        return <h6 className={className + "_error_text"}>
            {message}
        </h6>;
    }

}

export default withRouter(BeneficiaryTransactionCreation);
